import { profileTypeEndPoint, profileTypeEnum } from "@components/templates/Profile/ProfileHeader/profile-enum";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { transformData } from "@helpers/profileHelper";
import { toast } from "react-toastify";
import ProfileHeader from "@components/templates/Profile/ProfileHeader";
import { useDispatch } from "react-redux";
import { profileRedirectionIdHandler } from "@redux/PortProfile/portProfileSlice";
import { profileName, profileType } from "@utils/enum";

const Header = () => {
  const { portId } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [profileDetails, setProfileDetails] = useState({});
  const [copyText, setCopyText] = useState([]);
  const [copyTextPill, setCopyTextPill] = useState([]);
  const [profileId, setProfileId] = useState(null);
  const dispatch = useDispatch();

  const generateCopyTextArr = (data) => {
    return [
      { key: "Phone", label: transformData(data.phone, false, false), isCopy: true },
      { key: "Email", label: transformData(data.email, false, false), isCopy: true },
      { key: "Website", label: transformData(data.website, false, false), isWebsite: true, isCopy: false },
    ].filter((item) => item.label);
  };

  const generateCopyTextPillArr = (data) => {
    return [
      { key: "Latitude & Longitude", label: transformData(`${data.latitude}, ${data.longitude}`, false, false), isPill: true, backgroundColor: "#EFF8FF", isCopy: true },
      { key: "UN / Locode", label: transformData(data.unlocode, false, true), isPill: true, backgroundColor: "#fef3f2", isCopy: true },
      { key: "Port Type", label: transformData(data.derived_port_type, true, false), isPill: false, backgroundColor: "#ecfdf3", isCopy: false },
    ].filter((item) => item.label);
  };

  useEffect(() => {
    const requestPayload = {
      profile_type: profileTypeEnum.ports,
      _id: portId,
    };
    axios
      .post(profileTypeEndPoint.ports.getProfileHeaderDetails, requestPayload)
      .then((res) => {
        const { status, data } = res.data;
        if (status.toLowerCase() === "success" && data) {
          setLoading(false);
          const transFormResponse = {
            ...data,
            name: transformData(data.name, true, false),
            state: transformData(data.state, true, false),
            country: transformData(data.country, true, false),
            countryCode: transformData(data.country_code, false, true),
            address: transformData(data.address, true, false),
          };
          setProfileId(data?.elastic_data_id?.[0]);
          setProfileDetails(transFormResponse);
          setCopyText(generateCopyTextArr(data));
          setCopyTextPill(generateCopyTextPillArr(data));
          const { elastic_data_id } = data;
          dispatch(profileRedirectionIdHandler(elastic_data_id?.[0]));
        } else {
          throw new Error("");
        }
      })
      .catch(() => {
        setError(true);
        setLoading(false);
        toast.error("Something went wrong. Please try again later !!!");
      });
  }, [portId]);
  return <ProfileHeader profileId={profileId} showFavourites={true} profileType={profileType.ports} loading={loading} error={error} profileDetails={profileDetails} copyText={copyText} copyTextPill={copyTextPill} showProfilePill={profileName.ports} />;
};

export default Header;
